<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <div class="divider divider--gold mb-3"></div>

                    <h1 class="mb-5 font-h1 font-thin">
                        EDIT <span class="text-uppercase">{{ user.name }}</span>
                    </h1>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <b-form-input
                                type="text"
                                class="tb-form-field mb-0 font-h3"
                                v-model="form.name"
                                placeholder="Name"
                                required>
                            </b-form-input>

<!--                            <b-form-select-->
<!--                                class=" mb-3 font-h3"-->
<!--                                v-model="form.role"-->
<!--                                :options="role_options"-->
<!--                                required>-->
<!--                            </b-form-select>-->

                            <custom-select
                                :options="role_options"
                                :defaultvalue="form.role"
                                :heading="'Select a role'"
                                @option-selected="(option) => form.role = option.value">
                            </custom-select>

                            <b-form-input
                                class="tb-form-field mb-3 font-h3"
                                type="email"
                                v-model="form.email"
                                placeholder="Email"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-button type="submit" variant="primary tb-button tb-button--blue font-h3 font-thin">
                            SUBMIT CLIENT
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import userRepository from "@/repository/users";
    import CustomSelect from "@/components/CustomSelect";

    export default {
        components: {
            CustomSelect
        },

        props: ['id'],

        data(){
            return{
                user: null,
                loaded: false,
                role_options: [
                    {
                        'value': 'ADMIN',
                        'text': 'Admin',
                    },
                    {
                        'value': 'CLIENT',
                        'text': 'Client'
                    }
                ]
            }
        },

        computed: {
            form() {
                return {
                    ...this.user
                }
            }
        },

        methods: {
            onSubmit() {
                userRepository.update(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'User Edited',
                            text: 'New user successfully edited.'
                        });
                    }).catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            }
        },

        mounted() {
            userRepository.getById(this.id)
                .then(response => {
                    this.user = response.data;
                    this.loaded = true;
                });
        }
    }
</script>

<style scoped lang="scss">

</style>